import WeaLocaleProvider from "../../wea-locale-provider";
import WeaAvatar from "../../wea-avatar";

const getLabel = WeaLocaleProvider.getLabel;

const text = (item, field) => {
  let text = "";
  if (item[field] !== undefined) {
    text = item[field];
  }
  if (item[field + "span"] !== undefined) {
    text = item[field + "span"];
  }
  return text;
};
let timeout = null;

class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { datas, inputTop, inputBottom } = this.props;
    this.dataObj = {};
    const list = datas.map(item => {
      let crmNames = [];
      if (item.departmentname) crmNames.push(item.departmentname);
      if (item.supsubcompanyname) crmNames.push(item.supsubcompanyname);
      if (item.subcompanyname) crmNames.push(item.subcompanyname);
      item.crmNames = crmNames.join("／");
      this.dataObj[item.id] = item;
      // console.log('itme.workcode',item.workcode);
      let requestParams;
      try {
        if (item.requestParams) {
          requestParams = JSON.parse(item.requestParams);
        }
      } catch (e) {}
      return (
        <li
          className={this.cls(item)}
          onDoubleClick={this.onDoubleClick.bind(this, item)}
          onClick={this.onClick.bind(this, item)}
        >
          <div className="item-wrap">
            {/* <img
              className="wea-tree-hr-portrait"
              src={item.icon}
              onError={() =>
                (item.icon =
                  "/cloudstore/resource/pc/com/images/portrait_default.jpg")
              }
              alt="img"
            /> */}
            {/* <WeaAvatar className="wea-tree-hr-portrait" userId={item.id} /> */}
            <WeaAvatar
              className="wea-tree-hr-portrait"
              userId={item.id}
              requestParams={requestParams}
            />
            <div className="resource-content breakall">
              <div>
                {this.props.is_012app && item.workcode && (
                  <span title={item.workcode} style={{ marginRight: 10 }}>
                    {item.workcode}
                  </span>
                )}
                {inputTop || inputBottom
                  ? (inputTop || []).map(field => (
                      <span
                        style={{ marginRight: 5 }}
                        dangerouslySetInnerHTML={{ __html: text(item, field) }}
                      />
                    ))
                  : [
                      <span
                        key="lastname"
                        className="lastname"
                        title={item.lastname}
                      >
                        {item.lastname}
                      </span>,
                      <span
                        key="jobtitlename"
                        className="jobtitlename gray"
                        title={item.jobtitlename}
                      >
                        {item.jobtitlename}
                      </span>
                    ]}
              </div>
              <div>
                {inputTop || inputBottom ? (
                  (inputBottom || []).map(field => (
                    <span
                      style={{ marginRight: 5 }}
                      dangerouslySetInnerHTML={{ __html: text(item, field) }}
                    />
                  ))
                ) : (
                  <div className="gray" title={item.crmNames}>
                    {item.crmNames}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="icon-wrap" />
          <i className="icon-coms-Selected" />
        </li>
      );
    });
    return (
      <div className="wea-crm-list">
        <ul className="wea-crm-list-wrapper">{list}</ul>
        {list.length == 0 && (
          <div
            className="empty-tip"
            style={{ color: "#999", paddingTop: 30, textAlign: "center" }}
          >
            {getLabel(83320, "没有可显示的数据")}
          </div>
        )}
      </div>
    );
  }
  cls(item) {
    const { selectedKeys, filterData } = this.props;
    let cls = ["cursor-pointer"];
    if (selectedKeys && selectedKeys.indexOf(item.id) > -1) {
      cls.push("selected");
    }
    if (filterData) {
      let ids = [];
      filterData.forEach(d => {
        if (d.type == "resource") {
          ids.push(d.id);
        } else {
          d.users &&
            d.users.forEach(u => {
              ids.push(u.id);
            });
        }
      });
      if (ids.indexOf(item.id) > -1) {
        cls.push("hide");
      }
    }
    return cls.join(" ");
  }
  onClick(data) {
    let _this = this;
    // 取消上次延时未执行的方法
    clearTimeout(timeout);
    //执行延时
    timeout = setTimeout(function() {
      let { selectedKeys } = _this.props;
      let keys = selectedKeys ? [...selectedKeys] : [];
      let datas = [];
      if (keys.indexOf(data.id) > -1) {
        keys = keys.filter(k => k !== data.id);
      } else {
        keys.push(data.id);
      }
      keys.forEach(k => {
        _this.dataObj[k] && datas.push(_this.dataObj[k]);
      });
      _this.props.onClick && _this.props.onClick(keys, datas);
    }, 200);
  }
  onDoubleClick(data) {
    const { isSingle, is_012app } = this.props;
    if (isSingle && is_012app)
      alert(getLabel(385602, "请“单击”选择人员，不可“双击”"));
    clearTimeout(timeout);
    this.props.onDoubleClick && this.props.onDoubleClick([data]);
  }
}

export default Main;



// WEBPACK FOOTER //
// ./ecology9/wea-browser-test/components/WeaHrmList.js